<template>
  <nav class="navbar">
    <div class="navbar-logo">
      <router-link  to="/">
        <img  src="../assets/images/arrow-words.png" alt="stockhey logo">
      </router-link>
    </div>
    <div class="mobileTrue">
    <vue-menu >
      <li class="normali">
        <router-link to="/">首页</router-link>
      </li>
      <li class="normali">
        <router-link to="/rankindexcn">中国上市公司市值排行</router-link>
      </li>
      <li class="normali">
        <router-link to="/rankindexus">美股市值200强</router-link>
      </li>
      <li class="normali">
        <router-link to="/about">关于</router-link>
      </li>
    </vue-menu>
    </div>
    <div class="pcTrue">
      <ul class="pc">
       <li class="normali">
        <router-link to="/">首页</router-link>
      </li>
      <li class="normali">
        <router-link to="/rankindexcn">中国上市公司市值排行</router-link>
      </li>
      <li class="normali">
        <router-link to="/rankindexus">美股市值200强</router-link>
      </li>
      <li class="normali">
        <router-link to="/about">关于</router-link>
      </li>
      </ul>
    </div>
  </nav>
</template>

<script>
import vueToggleMenuPcMobile from '@/components/menu-toggle.vue'
export default {
  name: 'Nav',
  components: {
    'vue-menu': vueToggleMenuPcMobile
  },
  computed: {
  }
}
</script>

<style scoped>

.navbar{
  background-color:#D53A35;
  padding: 0;
  position: sticky;
  top: 0;
  z-index: 1;
}

div.pcTrue{
  display: none
}
@media(min-width: 500px){
  .navbar{
    padding: 0 15%;
    display: flex;
    min-height: 50px;
  }
  div.pcTrue{
    display: block
  }
  div.mobileTrue{
    display: none
  }

  }

li {
  list-style:none;
}
li.normali a{
      line-height: 20px;
      padding: 15px;
      color: #fff;
      text-decoration:none;
      display: block;
}

.navbar .navbar-logo {
  padding: 5px 0;
  min-height: 30px;
  display: block
}

@media(min-width: 500px){
  ul.pc {
    display: flex;
    margin: 0;
    padding: 0px;
  }
  .navbar .navbar-logo img {
    margin: 2px 2px 2px -15px;
  }
  .navbar li  a.router-link-exact-active.router-link-active, .navbar  li.normali  a:hover, .navbar  li.normali  a:focus{
  background-color: #162436;
  padding-top: 11px;
  border-top: 4px solid #a9334c;
  }}

</style>
